/* tslint:disable */
/* eslint-disable */
/**
 * AgentAssistService
 * Agent Assist API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CallingIdentity } from './CallingIdentity';
import {
    CallingIdentityFromJSON,
    CallingIdentityFromJSONTyped,
    CallingIdentityToJSON,
} from './CallingIdentity';

/**
 * 
 * @export
 * @interface DeleteAgentRequestContent
 */
export interface DeleteAgentRequestContent {
    /**
     * 
     * @type {CallingIdentity}
     * @memberof DeleteAgentRequestContent
     */
    callingIdentity: CallingIdentity;
}


/**
 * Check if a given object implements the DeleteAgentRequestContent interface.
 */
export function instanceOfDeleteAgentRequestContent(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "callingIdentity" in value;

    return isInstance;
}

export function DeleteAgentRequestContentFromJSON(json: any): DeleteAgentRequestContent {
    return DeleteAgentRequestContentFromJSONTyped(json, false);
}

export function DeleteAgentRequestContentFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeleteAgentRequestContent {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'callingIdentity': CallingIdentityFromJSON(json['callingIdentity']),
    };
}

export function DeleteAgentRequestContentToJSON(value?: DeleteAgentRequestContent | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'callingIdentity': CallingIdentityToJSON(value.callingIdentity),
    };
}

